import { Controller } from "@hotwired/stimulus";
import { initDropzone, initDropzoneBasicEvents } from "../../../components/dropzone";

const ACCEPTED_FORMATS = ".pdf";

export default class extends Controller {
  static targets = ["filePreviewsContainer", "uploadImgLabel", "dragAndDropContainer"];
  static values = { uploadOptions: Object };

  connect() {
    this._initDropzone();
  }

  _initDropzone() {
    this.dropzone = initDropzone(this.element.id, {}, this._uploadOptions());
    initDropzoneBasicEvents(this.dropzone, this.uploadImgLabelTarget, this.dragAndDropContainerTarget);
    this._initCustomEvents();
  }

  _uploadOptions() {
    return {
      previewsContainer: this.filePreviewsContainerTarget,
      paramName: this.uploadOptionsValue.paramName,
      acceptedFiles: ACCEPTED_FORMATS,
      maxFiles: this.uploadOptionsValue.maxFiles,
      autoUpload: true,
      clickable: `#${this.dragAndDropContainerTarget.id}`,
    };
  }

  _initCustomEvents() {
    if (this.uploadOptionsValue.maxFiles > 1) {
      this.dropzone.on("successmultiple", (e, response) => {
        this._filesUploaded(e, response);
      });
    } else {
      this.dropzone.on("success", (e, response) => {
        this._filesUploaded(e, response);
      });
    }
  }

  _filesUploaded = (e, response) => {
    Turbo.renderStreamMessage(response);

    // We dispatch this custom event to hide the file selection form when uploading PDF sales invoices, by calling the #filesAdded action in the upload-modal controller
    this.element.dispatchEvent(new CustomEvent("turbo:submit-end", { detail: [e.xhr] }));
  };
}
